import type { ListarProdutosModel } from "../models/listarProdutosModel"

export enum ListarProdutosActionsTypes {
    CARREGAR_RESULTADO = "CARREGAR_RESULTADO",
    CARREGAR_CATEGORIAS = "CARREGAR_CATEGORIAS",
}

type CarregarResultadoAction = {
    type: ListarProdutosActionsTypes.CARREGAR_RESULTADO
    payload: ListarProdutosModel["pontos"]
}

type CarregarCategoriasAction = {
    type: ListarProdutosActionsTypes.CARREGAR_CATEGORIAS
    payload: ListarProdutosModel["categorias"]
}

export type ListarProdutosAction = CarregarResultadoAction | CarregarCategoriasAction
